import { ComponentProps } from "react";
import { Link, NavLink, NavLinkProps } from "remix";

export interface HeaderOwnProps {}

export function AdminLink(props: NavLinkProps) {
  return (
    <NavLink
      className={({ isActive }) =>
        isActive
          ? "text-gray-300 underline hover:text-gray-400 p-2"
          : "text-gray-100 hover:underline hover:text-gray-400 p-2"
      }
      {...props}
    />
  );
}

export function Header({
  children,
  ...restProps
}: HeaderOwnProps & ComponentProps<"header">) {
  return (
    <>
      <header {...restProps}>
        <div className={`pb-6 pt-8 bg-primary-50 main-layout-centered`}>
          <div className="flex flex-row justify-between items-center">
            <Link to="/" className="flex flex-row">
              {/* <img alt="We Won't Shut Up! Logo" src="/favicon-32x32.png" /> */}
              <h1
                className={`text-lg md:text-3xl text-primary-700 font-extrabold`}
              >
                We Won't Shut Up!
              </h1>
            </Link>
            <nav>
              <Link className="ml-4 text-primary-700 font-bold" to="/about">
                Über uns
              </Link>
              <Link className="ml-4 text-primary-700 font-bold" to="/archive">
                Archiv
              </Link>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
}
